
export interface FaultCircuit {
  recordFault(): boolean;
  recordSuccess(): void;
  isOpen(): boolean;
}

export function createFaultCircuit(options?: {
  threshold?: number;
  openMs?: number;
  now?: () => number;
}): FaultCircuit {
  const threshold = options?.threshold ?? 3;
  const openMs = options?.openMs ?? 5 * 60_000;
  const now = options?.now ?? (() => Date.now());

  let consecutiveFaults = 0;
  let open = false;
  let openedAt = 0;

  return {
    recordFault(): boolean {
      const t = now();
      if (open) {
        if (t - openedAt < openMs) return true;
        open = false;
        consecutiveFaults = 0;
      }
      consecutiveFaults += 1;
      if (consecutiveFaults >= threshold) {
        open = true;
        openedAt = t;
        return true;
      }
      return false;
    },
    recordSuccess(): void {
      consecutiveFaults = 0;
      open = false;
    },
    isOpen(): boolean {
      return open && now() - openedAt < openMs;
    },
  };
}
